import { render } from "./SharedDataKeyCreate.vue?vue&type=template&id=0059f29e"
import script from "./SharedDataKeyCreate.vue?vue&type=script&lang=js"
export * from "./SharedDataKeyCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__